export const Purpose = ({ color }: { color: string; }) => {
  return <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="44" height="44" rx="8" fill={color}/>
  <path d="M22 12C16.48 12 12 16.48 12 22C12 27.52 16.48 32 22 32C27.52 32 32 27.52 32 22C32 16.48 27.52 12 22 12ZM26.15 22.83L24.42 23.41C23.94 23.57 23.57 23.94 23.41 24.42L22.83 26.15C22.34 27.64 20.24 27.61 19.78 26.12L17.83 19.84C17.45 18.59 18.6 17.44 19.83 17.82L26.12 19.77C27.61 20.24 27.63 22.34 26.15 22.83Z" fill="white"/>
  </svg>
  
}